import React from "react";
import L from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import { IcMapLocationPin } from "@racoon/icons";

/**
 * A site's own pin, its tip on the point. Icons/action blue: the pin follows the
 * design system, not the legacy brand blue.
 */
export const SITE_PIN_ICON = L.divIcon({
  className: "object-marker",
  html: `<div style="position: relative; width: 32px; height: 32px;">${renderToStaticMarkup(
    React.createElement(IcMapLocationPin, {
      width: "21",
      height: "25",
      style: { color: "#2563eb" },
    }),
  )}</div>`,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});
